import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';
import parse from 'html-react-parser';

function UpdateAnnouncement({ showMessage, id, setShowUpdate }) {
    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [date, setDate] = useState("");
    const [announcement, setAnnouncement] = useState(null);

    useEffect(() => {
        fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=getAnnouncementById&id=${id}`)
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setAnnouncement(data.announcement);
                    setTitle(data.announcement.title);
                    setBody(data.announcement.body);
                    setDate(data.announcement.date ? data.announcement.date.split(" ")[0] : "");
                } else {
                    console.error(data.error);
                }
            });
    }, [id]);

    useEffect(() => {
        fetch('https://annalsofnursing.org/aon_backend/api/api.php?action=checkUserSession', {
            method: 'GET',
            credentials: "include",
        })
            .then(res => res.json())
            .then(data => {
                if (data.success !== 'true') {
                    navigate("/dashboard/login");
                }
            })
            .catch(err => console.log(err));
    }, []);

    const updateAnnouncement = async () => {
        const hasChanged =
            title !== announcement.title ||
            body !== announcement.body ||
            date !== announcement.date;

        if (!hasChanged) {
            showMessage("info", "Nothing has changed.");
            return;
        }

        const formData = new FormData();
        formData.append("id", id);
        formData.append("title", title);
        formData.append("body", body);
        formData.append("date", date); // Optional

        try {
            const response = await fetch(`https://annalsofnursing.org/aon_backend/api/api.php?action=updateAnnouncement`, {
                method: 'POST',
                credentials: "include",
                body: formData
            });

            const data = await response.json();
            if (data.success) {
                showMessage("success", "Announcement updated successfully.");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                showMessage("error", data.error || "Update failed.");
            }
        } catch (err) {
            console.error(err);
            showMessage("error", "An error occurred during update.");
        }
    };

    const cancelUpdate = () => {
        setShowUpdate(false);
    };

    return (
        <div className='dash_update_records'>
            <label>1. Title</label><br />
            <input className='dash_input' type="text" value={title} onChange={(e) => setTitle(e.target.value)} /><br />

            <label>2. Body</label><br />
            {/* <input className='dash_input' type="text" value={body} onChange={(e) => setBody(e.target.value)} /><br /> */}
            <textarea
                className="dash_input"
                value={body}
                onChange={(e) => setBody(e.target.value)}
                rows={5}
            /><br />

            <label>3. Date (optional)</label><br />
            <input className='dash_input' type="date" value={date} onChange={(e) => setDate(e.target.value)} /><br />

            <br /><br />
            <div className='dash_buttons_wrapper'>
                <button className='dash_form_buttom' onClick={updateAnnouncement}>Update</button>
                <button className='dash_form_buttom dash_reset' onClick={cancelUpdate}>Cancel</button>
            </div>
        </div>
    );
}

export default UpdateAnnouncement;